import React from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Button, OfferPlan } from '../../common'

import { ampEvent } from '../../../utils/amplitude'
import { getUserId } from '../../../redux/slices/userSlice'
import { paramsToQuery } from '../../../utils/historyDecorators'

import './styles.scss'

const Price = ({
	isLegalFlow,
	setIsActiveModal,
	flow_tag,
	offers,
	handleSelectOffer,
	selectedOffer,
	initial_price,
}) => {
	const user_id = useSelector(getUserId)

	const handleBuySubscription = () => {
		setIsActiveModal(true)
		ampEvent('Checkout_shown')
		document.body.style.overflow = 'hidden'
	}

	const renderPrice = () => {
		const isLegalPrice = flow_tag && isLegalFlow

		switch (isLegalPrice) {
			case '':
			case true: {
				return (
					<div className="price__offer-plans">
						{offers.map(offer => (
							<OfferPlan
								key={offer.id}
								onOfferClicked={() => handleSelectOffer(offer.id)}
								{...offer}
							/>
						))}
						<Button buttonText="Try now" onClick={handleBuySubscription} />
					</div>
				)
			}
			case false: {
				return (
					<>
						<div className="price-info">
							<h3 className="price-info__title" id="price">
								Total due today:
								<span className="price-info__title--price">
									$0.{initial_price === 'flow_99' ? '99' : '00'}
								</span>
							</h3>
							<span className="price-info__subtitle">
								Included in your membership:
							</span>
							<div className="price-offers">
								<div className="pick-icon-wrapper">
									<img
										src="/images/sale/pick-icon.png"
										alt="pick"
										className="pick-icon"
									/>
								</div>
								<span className="price-offer">
									Refine gives 100% possibilities to make each photos amazing
								</span>
								<div className="pick-icon-wrapper">
									<img
										src="/images/sale/pick-icon.png"
										alt="pick"
										className="pick-icon"
									/>
								</div>
								<span className="price-offer">
									Lifetime access to app with all features makes realistic face
									swaps even more attractive
								</span>
								<div className="pick-icon-wrapper">
									<img
										src="/images/sale/pick-icon.png"
										alt="pick"
										className="pick-icon"
									/>
								</div>
								<span className="price-offer">
									You get a chance to edit photos 10 times faster due to
									artificial intelligence tools from the app
								</span>
							</div>
							<Button
								buttonText="Try for free"
								onClick={handleBuySubscription}
							/>
						</div>
					</>
				)
			}
			default: {
				return <p>Component now found</p>
			}
		}
	}

	return (
		<>
			<div className="price">
				<div className={`price__header ${isLegalFlow ? 'default' : ''}`}>
					<div
						className={`price__header__stars-rating ${
							isLegalFlow ? 'default' : ''
						}`}
					>
						<img
							src="/images/sale/stars-rating.png"
							alt="stars-rating"
							className={`price__header__stars-rating__image ${
								isLegalFlow ? 'default' : ''
							}`}
						/>
						<span className="price__header__stars-rating__text">
							30k+ reviews
						</span>
					</div>
					<h2
						className={`price__header__title ${isLegalFlow ? 'default' : ''}`}
					>
						Start Your
						<br />
						<span className="price__header__title--red">
							{isLegalFlow ? '3 days Trial for $0.99' : 'Free Trial'}
						</span>
					</h2>
				</div>
				<div className="video-wrapper">
					{flow_tag === '' ||
					flow_tag === '11' ||
					flow_tag === '33' ||
					flow_tag === '55' ? (
						<>
							<video
								autoPlay="autoplay"
								loop
								muted
								src="/videos/sale/royal-family.mp4"
								type="video/mp4"
								className="video"
								playsInline
							/>
							<img
								src="/images/sale/phone-frame-small.png"
								alt="phone-frame-small"
								className="phone-frame"
							/>
						</>
					) : (
						<>
							<video
								autoPlay="autoplay"
								loop
								muted
								src="/videos/sale/ad.mp4"
								type="video/mp4"
								className="video"
								playsInline
							/>
							<img
								src="/images/sale/phone-frame.png"
								alt="phone-frame"
								className="phone-frame"
							/>
						</>
					)}
				</div>
			</div>
			{renderPrice()}
			<p className="price-bottom-info">
				{isLegalFlow ? (
					<>
						By continuing you agree that if you don&apos;t cancel at least 24
						hours prior to the end of the{' '}
						<span className="price-bottom-info__accent">
							3-days trial for $0.99
						</span>
						, you will automatically be charged{' '}
						<span className="price-bottom-info__accent">
							${selectedOffer.pricePerPeriod}{' '}
							{selectedOffer.periodTime === 3 ? 'per 3' : 'every'}{' '}
							{selectedOffer.period}
						</span>{' '}
						until you cancel in settings. Learn more about cancellation and
						refund policy in{' '}
						<Link
							className="text-link"
							to={{
								pathname: '/subscription-terms',
								search: paramsToQuery({ user_id }),
							}}
						>
							Subscription Terms
						</Link>
						.
					</>
				) : (
					<>
						No charges for 3 days <br />
						Cancel anytime · $9.99 billed weekly
					</>
				)}
			</p>
		</>
	)
}

export { Price }
